exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\r\n    font-family: \"Lato\", sans-serif;\r\n    background-image:url(" + require("./header/img/bg2.png") + ") !important;\r\n  \r\n     background-size: 100% !important;\r\n                width:100% !important;\r\n              \r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/USer/Interviewfeedback/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main